import { render, staticRenderFns } from "./BookingExtras.vue?vue&type=template&id=5e68a9e1&scoped=true&lang=pug"
import script from "./BookingExtras.vue?vue&type=script&lang=js"
export * from "./BookingExtras.vue?vue&type=script&lang=js"
import style0 from "./BookingExtras.vue?vue&type=style&index=0&id=5e68a9e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e68a9e1",
  null
  
)

export default component.exports